"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const prop_types_1 = __importDefault(require("prop-types"));
const react_1 = __importDefault(require("react"));
const TableSelect = ({ checked, id, row, selectType, onClick }) => {
    const input = (react_1.default.createElement("div", { style: { textAlign: 'left' } },
        react_1.default.createElement("input", { checked: checked || false, style: { marginTop: 0 }, type: selectType, onClick: e => {
                const { shiftKey } = e;
                e.stopPropagation();
                onClick(id, shiftKey, row);
            }, onChange: () => { } })));
    return input;
};
TableSelect.propTypes = {
    checked: prop_types_1.default.bool,
    id: prop_types_1.default.string,
    row: prop_types_1.default.objectOf(prop_types_1.default.any),
    selectType: prop_types_1.default.string,
    onClick: prop_types_1.default.func.isRequired,
};
exports.default = TableSelect;
